import script from "./cadencia.vue?vue&type=script&setup=true&lang=js"
export * from "./cadencia.vue?vue&type=script&setup=true&lang=js"

import "./cadencia.vue?vue&type=style&index=0&id=11896247&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11896247"]])

export default __exports__